<template>
  <el-dialog
    class="xztz"
    title="消息"
    :visible.sync="visible"
    :before-close="close"
    append-to-body
  >
    <div class="dialog-content">
      <div class="message-list">
        <div class="message-item" v-for="item in messageList" :key="item.id">
          <div class="message-avatar">
              <img :src="item.avatar" class="lu-avatar"/>
              <div class="message-time" style="margin-top:10px;">{{ item.createTimeDate }}</div>
              <div class="message-time">{{ item.createTimeTime }}</div>
            </div>
          <div class="right">
            <div class="nick-name">{{ item.userName }}</div>
            <div class="text">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <Input v-model="reply" type="textarea" :rows="4" placeholder="请输入" autofocus />
      <div class="lu-footer">
        <Button class="send-btn" @click="close">关闭</Button>
        <Button class="send-btn" type="primary" @click="submit">发送</Button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "newsDialog",
  props:['visible','params'],
  data() {
    return {
      reply:'',
      messageList:[]
    };
  },
  created() {
    var that=this;
    that.$watch('visible', function() {
      if(that.visible){
        that.loadData();
      }
      
    });
  },
  methods: {
    submit(){
      var that=this;
      console.log('0101010',that.params);
      // TODO: 回复
      that.api.clientMessageSave({
        replyId: that.params.doctorId,
        receiverId: that.params.openid,
        relatedUserId: that.params.relatedUserId,
        content: that.reply,
        userName:that.params.userName
      })
      .then(function () {
        that.loadData();
        that.reply = null;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    close(){
      this.$emit("close");
    },
    loadData(){
     var that=this;
     var params={ id:that.params.id,isSend:that.params.isSend };
     that.api.clientMessageUpdate(params);
     that.api.clientMessageQuery({userId:that.params.userId}).then((response) => {
        if (response.data.code == 0) {
          var message=response.data.message;
          if(message){
            for(var i=0;i<message.length;i++){
              var item=message[i];
              var createTime=item.createTime;
              if(createTime){
                var times=createTime.split(' ');
                item.createTimeDate=times[0];
                item.createTimeTime=times[1];
              }
            }
          }
          that.messageList = message;
        }
      });
    }
  },
};
</script>
<style lang="less">
.dialog-content
{
  
}
.message-list {
  height: 300px;
  overflow-y: scroll;
  .message-item {
    display: flex;
    margin-bottom: 30px;
    height: 64px;
    align-items: center;

    .right {
      display: flex;
      flex-direction: column;
      margin-left: 25px;
      flex: 1;
      .nick-name {
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.65);
        line-height: 32px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 32px;
      }
    }
  }
}
.lu-footer{
    margin-top: 10px;
    .send-btn{
    margin-left: 10px;
    }
}
.message-avatar{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}
.message-time{
    font-size:10px;
    color:rgba(0, 0, 0, 0.65);
}
</style>
